import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export const ToggleButtonSearch = ({
	value,
	onChange,
}: {
	value: "new" | "search";
	onChange: (value: string) => void;
}) => {
	const handleChange = (event: any, newValue: any) => {
		if (newValue !== null) {
			onChange(newValue);
		}
	};

	return (
		<ToggleButtonGroup
			value={value}
			exclusive
			onChange={handleChange}
			aria-label="text alignment"
		>
			<ToggleButton value="new">NEW ADJUSTMENT</ToggleButton>
			<ToggleButton value="search">SELECT ADJUSTMENT</ToggleButton>
		</ToggleButtonGroup>
	);
};
